// How this store was opened:
// - custom domain / legacy subdomain (minhaloja.com.br, x.bardyapp.com): the API finds the store by the domain;
// - platform temporary address (bardyapp.com.br/<slug>/...): the first path segment is the store slug,
//   sent to the API in the X-Store-Slug header, and every route lives under /<slug>/.

const DEFAULT_PLATFORM_HOSTS = 'bardyapp.com.br,www.bardyapp.com.br'

const platformHosts: string[] = String(process.env.VUE_APP_PLATFORM_HOSTS || DEFAULT_PLATFORM_HOSTS)
    .split(',')
    .map((host: string) => host.trim().toLowerCase())
    .filter(Boolean)

/** Where a visitor without a store can create one. */
export const landingUrl: string = process.env.VUE_APP_LANDING_URL || 'https://bardy.com.br'

const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{0,79}$/

export const isPlatformHost = platformHosts.includes(window.location.hostname.toLowerCase())

const firstSegment = decodeURIComponent(window.location.pathname.split('/')[1] || '').toLowerCase()

/** Store slug from the URL when opened through the platform address; null otherwise (or when missing/invalid). */
export const storeSlug: string | null = isPlatformHost && SLUG_PATTERN.test(firstSegment) ? firstSegment : null

/** Base path for the router: "/<slug>/" on the platform address, "/" on custom domains. */
export const routerBase = storeSlug ? `/${storeSlug}/` : '/'

/** Platform address opened without a store slug (e.g. https://bardyapp.com.br/). */
export const isMissingStoreSlug = isPlatformHost && !storeSlug
